import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class AutenticidadeService extends ServiceBase {

    title = "Autenticidade"
    pluralTitle = "Autenticidades"
    url = '/cadastro/produto/autenticidade'
    frontUrl = '/cadastro/produto/autenticidade'
    frontUrlList = '/cadastro/produto/autenticidadelist'
    primaryKey = 'codigo_aute'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.ativo_aute = boolToNumber(data.ativo_aute, true)

        return data
    }

    prepareToSave({ data }) {

        data.ativo_aute = boolToNumber(data.ativo_aute)

        delete data.meta

        return data

    }

}
